import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import Data from 'Content/content.json';
import { language, LANG_JP, LANG_ZH, LANG_HK, LANG_TH, LANG_RU, LANG_VI, LANG_FIL } from 'Root/constants';

const DisclaimerContent = ({ data }) => (
  <ul className="disclaimer--requirement">
    {data.map((item, idx) => (
      <li
        key={idx}
        className="disclaimer--requirement__item"
        dangerouslySetInnerHTML={{ __html: item }}
      />
    ))}
  </ul>
);

const Disclaimer = ({ lensIndex }) => {
  const {
    data: {
      disclaimer,
      additional_disclaimer,
      medical_requirement: { first, second },
      medical_additional: { info },
    },
  } = Data;
  const totalData = [{ data: first }, { data: second }, { data: info }];
  return (
    <Fragment>
      {language === LANG_JP &&
        totalData.map(({ data }, idx) => (
          <DisclaimerContent key={idx} data={data} />
        ))}
      {language === LANG_HK && (
        <div className="disclaimer--warning">
          <FormattedMessage
            id="products.disclaimer_warning"
            defaultMessage="Lens effects are for reference only"
          />
        </div>
      )}
      {disclaimer[language] && (
        <div className="disclaimer">
          {language !== LANG_JP && language !== LANG_TH && language !== LANG_RU && language !== LANG_VI && language !== LANG_FIL && (
            <div className="disclaimer--title">
              <FormattedMessage
                id="products.disclaimer_header"
                defaultMessage="REFERENCES/ DISCLAIMER"
              />
            </div>
          )}
          <div className="disclaimer--content">
            {disclaimer[language].map((item, idx) => (
              <p key={idx} dangerouslySetInnerHTML={{ __html: item }} />
            ))}
            {language === LANG_ZH && (
              <p>{additional_disclaimer.lens[lensIndex]}</p>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Disclaimer;
